import type { BlogStageTab } from "./types";

export const BLOG_ARTICLES_COLLECTION = "blog-articles";
export const FEATURED_ARTICLES_COLLECTION = "articles-home-featured-limited";

export const LATEST_TAB_ID = "latest";

export const HERO_POST_COUNT = 4;
export const HERO_SLIDE_DURATION_MS = 5000;
export const RECENT_POST_COUNT = 9;
export const REGION_POST_COUNT = 3;
export const ALL_BLOGS_PAGE_SIZE = 12;
export const REGION_PAGE_SIZE = 9;

export const STAGE_QUERY_PARAM = "stage";

export const ALL_BLOGS_SCOPE = "all";
export const ALL_GUIDES_TAB_ID = "all-guides";

export const BLOG_STAGE_TABS: BlogStageTab[] = [
  { id: LATEST_TAB_ID, labelKey: "blog.home.tabs.latest" },
  {
    id: "where-to-study",
    labelKey: "blog.home.tabs.whereToStudy",
    stageSlug: "where-to-study",
  },
  {
    id: "planning-and-budget",
    labelKey: "blog.home.tabs.planningAndBudget",
    stageSlug: "planning-and-budget",
  },
  {
    id: "search-and-shortlist",
    labelKey: "blog.home.tabs.searchAndShortlist",
    stageSlug: "search-and-shortlist",
  },
  {
    id: "evaluate-and-view",
    labelKey: "blog.home.tabs.evaluateAndView",
    stageSlug: "evaluate-and-view",
  },
  {
    id: "book-and-contract",
    labelKey: "blog.home.tabs.bookAndContract",
    stageSlug: "book-and-contract",
  },
  {
    id: "arrive-and-move-in",
    labelKey: "blog.home.tabs.arriveAndMoveIn",
    stageSlug: "arrive-and-move-in",
  },
  {
    id: "live-and-move-out",
    labelKey: "blog.home.tabs.liveAndMoveOut",
    stageSlug: "live-and-move-out",
  },
];

export const getStageTab = (tabId?: string | null): BlogStageTab =>
  BLOG_STAGE_TABS.find(({ id }) => id === tabId) ?? BLOG_STAGE_TABS[0];

export const BLOG_REGION_TABS: BlogStageTab[] = [
  { id: ALL_GUIDES_TAB_ID, labelKey: "blog.region.tabs.allGuides" },
  {
    id: "city-and-neighbourhood",
    labelKey: "blog.region.tabs.cityAndNeighbourhood",
    categorySlug: "city-and-neighbourhood",
  },
  {
    id: "renting-basics",
    labelKey: "blog.region.tabs.rentingBasics",
    categorySlug: "renting-basics",
  },
  {
    id: "planning-and-budget",
    labelKey: "blog.home.tabs.planningAndBudget",
    stageSlug: "planning-and-budget",
  },
  {
    id: "arrive-and-move-in",
    labelKey: "blog.home.tabs.arriveAndMoveIn",
    stageSlug: "arrive-and-move-in",
  },
  {
    id: "universities",
    labelKey: "blog.region.tabs.universities",
    categorySlug: "universities",
  },
];

export const getRegionTab = (tabId?: string | null): BlogStageTab =>
  BLOG_REGION_TABS.find(({ id }) => id === tabId) ?? BLOG_REGION_TABS[0];

export const getListingKey = (scope: string, tabId: string): string => `${scope}:${tabId}`;

export const getRegionScope = (countrySlug: string): string => `region-${countrySlug}`;

export const CATEGORY_PAGE_SIZE = 12;
export const CATEGORY_SCOPE = "category";

export const BLOG_REGION_COUNTRY_SLUGS = ["uk", "usa", "germany", "australia"];
